export type AmountSign = '+' | '-' | null;

export type AmountTone = 'positive' | 'negative' | 'neutral';

export type OperationAmountSign = {
  sign: AmountSign;
  tone: AmountTone;
};

// Keyed on the operation type name (the GraphQL __typename and the
// browserextension `operationType` string are the same values). Sign and tone
// travel together because DebitOut and DebitInReturn arrive already signed
// from the backend: nothing is prepended, but they still read as outflows.
const OPERATION_TYPE_AMOUNT_SIGN: Record<string, OperationAmountSign> = {
  DepositEventOperation: { sign: '+', tone: 'positive' },
  DebitInOperation: { sign: '+', tone: 'positive' },
  DebitOutReturnOperation: { sign: '+', tone: 'positive' },
  WithdrawOperation: { sign: '-', tone: 'negative' },
  TransferOperation: { sign: '-', tone: 'negative' },
  DebitOutOperation: { sign: null, tone: 'negative' },
  DebitInReturnOperation: { sign: null, tone: 'negative' },
  LockOperation: { sign: null, tone: 'neutral' },
  UnlockOperation: { sign: null, tone: 'neutral' },
};

// Undefined means the operation type moves no asset amount.
export const getOperationTypeAmountSign = (
  operationType: string,
): OperationAmountSign | undefined => OPERATION_TYPE_AMOUNT_SIGN[operationType];
